import { render } from "./FavoContents.vue?vue&type=template&id=19bee794"
import script from "./FavoContents.vue?vue&type=script&lang=js"
export * from "./FavoContents.vue?vue&type=script&lang=js"

import "./FavoContents.vue?vue&type=style&index=0&id=19bee794&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__